__turbopack_context__.v({
  "buttonClose": "h-YItW_buttonClose",
  "contacts": "h-YItW_contacts",
  "container": "h-YItW_container",
  "content": "h-YItW_content",
  "header": "h-YItW_header",
  "linkLogo": "h-YItW_linkLogo",
  "logo": "h-YItW_logo",
  "navigation": "h-YItW_navigation",
});
